module.exports = __webpack_public_path__ + "img/1.897d45a6.png";